"use client";

import { useAuth } from "@/hooks/useAuth";
import { ProfileTabsEnum } from "@/src/@types/Profile";
import AgentHomePage from "@/src/app/[locale]/(private)/profile/[tab]/components/agent/AgentHomePage";
import { ChatProviders } from "@/src/providers/ChatProviders";

import MyConnections from "./components/MyConnections";
import { MyMessages } from "./components/MyMessages";
import { MyOrganizationProfile } from "./components/MyOrganizationProfile";
import MySavedJobs from "./components/MySavedJobs";
import MySettings from "./components/MySettings";
import { ResourceCenter } from "./components/resource-center/ResourceCenter";
import { UserProfileHome } from "./components/UserProfileHome";
import { UserProfilePage } from "./components/UserProfilePage";

export default function Page({
  params: { tab },
}: {
  params: { tab: string };
}): JSX.Element {
  const { authData } = useAuth();

  if (authData?.type === "agent" && tab !== "settings") {
    return <AgentHomePage authData={authData} />;
  }

  return (
    <UserProfilePage tab={tab}>
      {tab === ProfileTabsEnum.HOME ? <UserProfileHome /> : null}
      {tab === ProfileTabsEnum.ORGANIZATION_PROFILE ? (
        <MyOrganizationProfile />
      ) : null}
      {tab === ProfileTabsEnum.MY_SAVED_JOBS ? <MySavedJobs /> : null}
      {tab === ProfileTabsEnum.MY_CONNECTIONS ? <MyConnections /> : null}
      {tab === ProfileTabsEnum.MY_MESSAGES ? (
        <ChatProviders>
          <MyMessages />
        </ChatProviders>
      ) : null}
      {tab === ProfileTabsEnum.MyDocuments ? <ResourceCenter /> : null}
      {tab === ProfileTabsEnum.SETTINGS ? <MySettings /> : null}
    </UserProfilePage>
  );
}
